import { getAuthToken } from '../utils/cookieUtils';
import { API_CONFIG } from '../utils/constants';
import axios from 'axios';

let _cache = null;
let _pending = null;

/**
 * Fetches breakdown statuses from the getbreakdownstatuses endpoint.
 * Deduplicates concurrent requests and caches the result for the lifetime of the page session.
 * @returns {Promise<Array<{ value: number, name: string }>>}
 */
export const loadBreakdownStatuses = async () => {
  if (_cache) return _cache;
  if (_pending) return _pending;

  _pending = axios.get(
    `${API_CONFIG.BASE_URL}${API_CONFIG.BREAKDOWNS.GET_STATUSES}`,
    { headers: { Authorization: `Bearer ${getAuthToken()}`, Accept: '*/*' } }
  ).then(res => {
    const statuses = Array.isArray(res.data?.statuses) ? res.data.statuses : [];
    _cache = statuses.map(s => ({ value: s.Value, name: s.Name }));
    _pending = null;
    return _cache;
  }).catch(() => {
    _pending = null;
    return [];
  });

  return _pending;
};
